export default __webpack_public_path__ + "static/media/ProductSans-Regular.9ccaabc5.woff2";